import { useContext } from "react";
import { FormContext, FormContextValue } from "@welldigital/components";

export default function useFormContext() {
  return useContext<FormContextValue>(FormContext);
}
